import React from "react";
import AttorneyInformationBase from "../../../../features/bonds/shared/components/AttorneyInformationBase";
import { HISTORIC_ATTORNEY_INFO_CONFIG } from "../historicAttorneyConfig";
import { HISTORIC_DATA_UPDATE_ERRORS } from "./historicCreationSharedPropTypes";

const TrusteeHistoricAttorneyInformationForm = ({ data, updateData, errors }) => (
  <AttorneyInformationBase
    cfg={HISTORIC_ATTORNEY_INFO_CONFIG.trustee}
    data={data}
    updateData={updateData}
    errors={errors}
    isGuest={false}
  />
);

TrusteeHistoricAttorneyInformationForm.propTypes = HISTORIC_DATA_UPDATE_ERRORS;

export default TrusteeHistoricAttorneyInformationForm;
